const ROWS = [
    { spec: "Standard", value: "UL300a (Certified by Intertek)" },
    { spec: "Coverage — Single Nozzle", value: 'Up to 30" (4-burner) cooking surface' },
    { spec: "Coverage — Dual Nozzle", value: 'Up to 48" cooking surface' },
    { spec: "Range Compatibility", value: "Gas + Electric (single SKU per fuel)" },
    { spec: "Suppressant", value: "1 L UL300a-compliant wet-chemical cylinder" },
    { spec: "Manifold", value: "Stainless-steel · braided steel supply hose" },
    { spec: "Heat Sensor", value: "Two-stage · audible elevated-heat warning" },
    { spec: "Auto Shutoff", value: "Gas solenoid OR electric relay (per fuel)" },
    { spec: "Pressure Monitoring", value: "Low-suppressant cylinder pressure warning" },
    { spec: "Control Panel", value: 'Self-contained "black box" · mountable to 15 ft' },
    { spec: "Alarm Output", value: "Central alarm terminal connection (acts as fire alarm)" },
    { spec: "Manual Actuation", value: "Pull station · reset/test tool included" },
    { spec: "Inspection Cadence", value: "6-month + annual (per most state codes)" },
    { spec: "Inclusions", value: "Nozzle assembly, metron/squib, fittings — install-ready" },
];

function SpecHeader() {
    return (
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
            <div className="lg:col-span-6">
                <div className="flex items-center gap-3 mb-6">
                    <span className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-[#E53935]">
                        / 03 — Technical Sheet
                    </span>
                </div>
                <h2 className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
                    Every part.
                    <br />
                    <span className="text-[#E53935] italic font-medium">Documented.</span>
                </h2>
            </div>
            <div className="lg:col-span-5 lg:col-start-8 flex items-end">
                <p className="text-base md:text-lg text-[#a1a1aa] leading-relaxed">
                    What ships in the box, what it does, and what code it satisfies — on one page,
                    in one cut-sheet.
                </p>
            </div>
        </div>
    );
}

function SpecRow({ row }) {
    return (
        <div className="grid grid-cols-12 px-6 md:px-8 py-4 md:py-5 border-b border-white/5 hover:bg-[#141416] transition-colors group">
            <div className="col-span-5 md:col-span-4 font-mono-tech text-xs text-[#a1a1aa] group-hover:text-white transition-colors">
                {row.spec}
            </div>
            <div className="col-span-7 md:col-span-8 font-display font-medium text-sm md:text-base text-white">
                {row.value}
            </div>
        </div>
    );
}

function SpecTable() {
    return (
        <div data-testid="spec-table" className="border border-white/10 bg-[#0a0a0b]">
            <div className="grid grid-cols-12 px-6 md:px-8 py-4 border-b border-white/10 bg-[#141416]">
                <div className="col-span-5 md:col-span-4 font-mono-tech text-[11px] uppercase tracking-[0.22em] text-[#71717a]">
                    Parameter
                </div>
                <div className="col-span-7 md:col-span-8 font-mono-tech text-[11px] uppercase tracking-[0.22em] text-[#71717a]">
                    Value
                </div>
            </div>
            {ROWS.map((row) => (
                <SpecRow key={row.spec} row={row} />
            ))}
        </div>
    );
}

export default function Specifications() {
    return (
        <section
            id="specifications"
            data-testid="specifications-section"
            className="relative py-20 md:py-24 border-t border-white/10 bg-grid-fine"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                <SpecHeader />
                <SpecTable />
            </div>
        </section>
    );
}
